var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconGrid = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M7.9,3h3.8c0.6,0,1.1,0.5,1.1,1.1v7.6c0,0.6-0.5,1.1-1.1,1.1H7.9 M7.9,3H4.1 C3.5,3,3,3.5,3,4.1v7.6c0,0.6,0.5,1.1,1.1,1.1h3.8" }),
            React.createElement("path", { d: "M22.1,3h3.8 C26.5,3,27,3.5,27,4.1v7.6c0,0.6-0.5,1.1-1.1,1.1h-3.8 M22.1,3h-3.8c-0.6,0-1.1,0.5-1.1,1.1v7.6c0,0.6,0.5,1.1,1.1,1.1h3.8" }),
            React.createElement("path", { d: "M22.1,17.2h3.8 c0.6,0,1.1,0.5,1.1,1.1v7.6c0,0.6-0.5,1.1-1.1,1.1h-3.8 M22.1,17.2h-3.8c-0.6,0-1.1,0.5-1.1,1.1v7.6c0,0.6,0.5,1.1,1.1,1.1h3.8" }),
            React.createElement("path", { d: "M7.8,17.2h3.8 c0.6,0,1.1,0.5,1.1,1.1v7.6c0,0.6-0.5,1.1-1.1,1.1H7.8 M7.8,17.2H4c-0.6,0-1.1,0.5-1.1,1.1v7.6C2.9,26.5,3.4,27,4,27h3.8" }))));
});
export default IconGrid;
//# sourceMappingURL=IconGrid.js.map